import { FC } from "react";
import { convertDate } from "helpers";
import cn from "classnames";
import styles from "./ShortHistoryChanges.module.sass";

const titleCategorized = {
	NOT_CATEGORIZED: "Категорирование не проводилось",
	PRIMARY_STARTED: "Первичное категорирование начато",
	PRIMARY_DONE: "Первичное категорирование завершено",
	SECONDARY_STARTED: "Последующее (повторное) категорирование начато",
	SECONDARY_DONE: "Последующее (повторное) категорирование завершено",
};

interface RowProps {
	row: {
		responsible: { fullName: string; id?: number | null | undefined };
		status: "NOT_CATEGORIZED" | "PRIMARY_STARTED" | "PRIMARY_DONE" | "SECONDARY_STARTED" | "SECONDARY_DONE";
		timestamp: string;
	};
}

const Row: FC<RowProps> = ({ row }) => {
	return (
		<div className={styles.tableRow}>
			<div>
				<div className={styles.tableRowTd}>{row.responsible?.fullName}</div>
				<div className={cn(styles.tableRowTd, styles.date)}>{convertDate(row?.timestamp)}</div>
			</div>
			<div className={styles.tableRowTd}>{titleCategorized[row?.status]}</div>
		</div>
	);
};

export default Row;
